import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';

import {withRouter} from "react-router-dom";
import Button from "../../ui/components/buttons/button";
import Template from "../template/template";
import Call from '../../assets/Call.svg';
import Email from '../../assets/Email.svg';
import PeopleOutline from '../../assets/PeopleOutline.svg';
import People from '../../assets/People.svg';
import Store from '../../assets/Store.svg';
import Dollar from '../../assets/Dollar.png';

import "./quote-size.css";
import {_getSite, _getStep, _hideModal, _showError, _showModal} from "../../store/system/service";
import {_getPolicy, _storePolicy} from "../../store/policy/service";
import RadioBox from "../radio-box";
import {_gaPushData, _gaPushEvent} from '../../utils/utility'
import ErrorMessage from "../error-message";

const options = [
    {
        label: 'Yes',
        value: 'true'
    },
    {
        label: 'No',
        value: 'false'
    }
];

const QuoteSize = (props) => {
    const [bizSize, setBizSize] = useState(props.policy.size);
    const [toggleAlert, setToggleAlert] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
        // Google Analytics
        _gaPushData({
            'pageStep': 'Quote',
            'vPath': '/quote',
            'event': 'vpageview',
            'ecommerce': {
                'checkout': {
                    'actionField': {'step': 2},
                }
            }
        });
    }, [])

    const selectSize = (newBizSize) => {

        if (newBizSize === 'false') {
            _gaPushData({
                'event': 'vpageview',
                'pageStep': 'contactus',
                'vPath': '/contactus'
            });
            _gaPushEvent('BusinessSizeNo');
            if (props.site === 'bm') {
                props.showModal(
                    {
                        marginTop: '23px',
                        icon: PeopleOutline,
                        title: 'Please contact our Brian Mae      Insurance Broker',
                        content:
                            <div className="QuoteContent">
                                Brian Mae Pte Ltd.
                                <br/>
                                <img align="center" src={Call} className="QuoteSizePhone"/> +65 6224 6633 <br/>
                                <div className="QuoteContentBufferStyle"></div>
                                <img align="center" src={Email} className="QuoteSizeEmail"/> SME@brianmae.com
                            </div>,
                        primaryAction: {
                            label: 'Email Us',
                            onClick: emailUs
                        },
                        secondaryAction: {
                            label: 'Contact Us Later',
                            onClick: contactUs
                        }
                    }
                )
            }
            else if(props.site === 'mla'){
                props.showModal(
                    {
                        marginTop: '23px',
                        icon: PeopleOutline,
                        title: 'Please contact our Multi-Lines Agencies       Insurance Agency',
                        content:
                            <div className="QuoteContent MLA">
                                Multi-Lines Agencies
                                <br/>
                                <div className={'mla-popup'} >
                                    <img src={Call} className="QuoteSizePhone" style={{'margin-right':'3px'}}/>
                                    + 65 9820 4276 / <br className={'mobileOnlyBr'}/>8499&nbsp;0385&nbsp;/&nbsp;9171&nbsp;1477
                                </div>
                                <div className="QuoteContentBufferStyle"></div>
                                <img align="center" src={Email} className="QuoteSizeEmail"/> info@multilines.com.sg
                            </div>,
                        primaryAction: {
                            label: 'Email Us',
                            onClick: emailUs
                        },
                        secondaryAction: {
                            label: 'Contact Us Later',
                            onClick: contactUs
                        }
                    }
                )
            }
            else {
                props.showModal(
                    {
                        marginTop: '23px',
                        icon: PeopleOutline,
                        title: 'Please contact our g&m       Insurance Broker',
                        content:
                            <div className="QuoteContent">
                                g&m Pte Ltd.
                                <br/>
                                <img align="center" src={Call} className="QuoteSizePhone"/> +65 6576 9855 <br/>
                                <div className="QuoteContentBufferStyle"></div>
                                <img align="center" src={Email} className="QuoteSizeEmail"/> corporate@gnm.com.sg
                            </div>,
                        primaryAction: {
                            label: 'Email Us',
                            onClick: emailUs
                        },
                        secondaryAction: {
                            label: 'Contact Us Later',
                            onClick: contactUs
                        }
                    }
                )
            }
        }

        setBizSize(newBizSize);

        setToggleAlert(false);
    }

    const emailUs = () => {
        _gaPushEvent('viewcloseemail');
        if (props.site === 'bm') {
            window.location = "mailto:SME@brianmae.com";
        }
        else if(props.site === 'mla'){
            window.location = "mailto:info@multilines.com.sg"
        }
        else {
            window.location = "mailto:corporate@gnm.com.sg";
        }
    }

    const contactUs = () => {
        _gaPushEvent('viewclosecontactuslater');
        props.hideModal();
    }

    const continueNextPage = () => {
        if (!bizSize) {
            setToggleAlert(true);
        }
        else if (bizSize === 'true') {
            props.policy.size = bizSize;
            props.storePolicy(props.policy);
            props.history.push((props.site ? '/' + props.site : '') + '/quote/product');
        }
        else {
            _gaPushData({
                'event': 'vpageview',
                'pageStep': 'BizNoContinueContactUs',
                'vPath': '/biznocontinuecontactus'
            });

            if (props.site === 'bm') {
                props.showModal(
                    {
                        marginTop: '23px',
                        icon: PeopleOutline,
                        title: 'Please contact our Brian Mae      Insurance Broker',
                        content:
                            <div className="QuoteContent">
                                Brian Mae Pte Ltd.
                                <br/>
                                <img align="center" src={Call} className="QuoteSizePhone"/> +65 6224 6633 <br/>
                                <div className="QuoteContentBufferStyle"></div>
                                <img align="center" src={Email} className="QuoteSizeEmail"/> SME@brianmae.com
                            </div>,
                        primaryAction: {
                            label: 'Email Us',
                            onClick: emailUs
                        },
                        secondaryAction: {
                            label: 'Contact Us Later',
                            onClick: contactUs
                        }
                    }
                )
            }
            else if(props.site === 'mla'){
                props.showModal(
                    {
                        marginTop: '23px',
                        icon: PeopleOutline,
                        title: 'Please contact our Multi-Lines Agencies       Insurance Agency',
                        content:
                            <div className="QuoteContent MLA">
                                Multi-Lines Agencies
                                <br/>
                                <div className={'mla-popup'} >
                                    <img src={Call} className="QuoteSizePhone" style={{'margin-right':'3px'}}/>
                                    + 65 9820 4276 / <br className={'mobileOnlyBr'}/>8499&nbsp;0385&nbsp;/&nbsp;9171&nbsp;1477
                                </div>
                                <div className="QuoteContentBufferStyle"></div>
                                <img align="center" src={Email} className="QuoteSizeEmail"/> info@multilines.com.sg
                            </div>,
                        primaryAction: {
                            label: 'Email Us',
                            onClick: emailUs
                        },
                        secondaryAction: {
                            label: 'Contact Us Later',
                            onClick: contactUs
                        }
                    }
                )
            }
            else {
                props.showModal(
                    {
                        marginTop: '23px',
                        icon: PeopleOutline,
                        title: 'Please contact our g&m      Insurance Broker',
                        content:
                            <div  className="QuoteContent">
                                g&m Pte Ltd.
                                <br/>
                                <img align="center" src={Call} className="QuoteSizePhone"/> +65 6576 9855 <br/>
                                <div className="QuoteContentBufferStyle"></div>
                                <img align="center" src={Email} className="QuoteSizeEmail"/> corporate@gnm.com.sg
                            </div>,
                        primaryAction: {
                            label: 'Email Us',
                            onClick: emailUs
                        },
                        secondaryAction: {
                            label: 'Contact Us Later',
                            onClick: contactUs
                        }
                    }
                )
            }

        }
    }

    return (
        <Template quote step={props.step} policy={props.policy} site={props.site} prevPage="/" >

            <div className="QuoteSizeTitleGroupStyle">
                <div className="QuoteSizeTitleStyle">My business has less than:</div>
            </div>
            <div className="QuoteSizeGroupsStyle">

                <div className="QuoteSizeGroupStyle">
                    <div className="QuoteSizeItemStyle">
                        <img src={People} />
                        <div className="QuoteSizeTextStyle">
                            100 Employees
                        </div>
                    </div>
                    <div className="QuoteSizePath" />
                    <div className="QuoteSizeItemStyleWide">
                        <img src={Store} />
                        <div className="QuoteSizeTextStyleWide">
                            $15M<br/><div className="QuoteSizeSpace"/>
                            Property Sum Insured
                        </div>
                    </div>
                    <div className="QuoteSizePath" />
                    <div className="QuoteSizeItemStyle">
                        <img src={Dollar} className="QuoteDollarStyle"/>
                        <div className="QuoteSizeTextStyle">
                            <span id="QuoteSizeAmountSpan">$20M</span><br/><div className="QuoteSizeSpace"/>
                            Turnover/Revenue
                        </div>
                    </div>

                </div>

                <RadioBox
                    options={options}
                    value={bizSize}
                    onClick={selectSize}
                />
            </div>
            <div className="QuoteSizeDeclaration">
                <div className="title">
                    Requirements:
                </div>
                <div className="contents">
                    <ul>
                        <li>The type of insurance proposed has not been declined, cancelled, refused renewal or subject to any special terms by any other insurance company.</li>
                        <li>The type of insurance proposed has not had more than 4 claims in the last 3 years.</li>
                        <li>Reasonable precautions have been taken to prevent and mitigate any potential losses for the business.</li>
                    </ul>
                </div>
            </div>
            {!!toggleAlert && (
                <ErrorMessage>
                    Please select business size.
                </ErrorMessage>
            )}
            <div className="QuoteSizeBtnGroupStyle">
                <Button color="primary" onClick={continueNextPage}>Continue</Button>
            </div>
        </Template>
    );

}

const mapStateToProps = (state) => {
    return {
        policy: _getPolicy(state),
        step: _getStep(state),
        site: _getSite(state)
    }
}

const mapDispatchToProps = {
    storePolicy: _storePolicy,
    showError: _showError,
    showModal: _showModal,
    hideModal: _hideModal
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuoteSize));
